import React, { useEffect, useState } from 'react';
import './StatusTab.css';
import './AdminTab.css';

const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

// Tamanho legível: KB/MB abaixo de 1 GB, GB a partir daí.
const fmtBytes = (b) => {
  const n = Number(b) || 0;
  const nf = (v, d) => v.toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d });
  if (n >= 1024 ** 3) return `${nf(n / 1024 ** 3, 2)} GB`;
  if (n >= 1024 ** 2) return `${nf(n / 1024 ** 2, 1)} MB`;
  return `${nf(n / 1024, 0)} KB`;
};

function AdminTab({ svc }) {
  const [users, setUsers] = useState(null);
  const [dbInfo, setDbInfo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const d = await svc.getAdminUsers();
      if (d.error) throw new Error(d.error);
      setUsers(d.users || []);
      setDbInfo({ total: d.db_total_bytes || 0, outros: d.db_outros_bytes || 0 });
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleAiAccess = async (u) => {
    const novoValor = !u.allow_system_ai;
    setSavingId(u.id);
    setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, allow_system_ai: novoValor } : x)));
    try {
      const d = await svc.setAdminUserAiAccess(u.id, novoValor);
      if (d.error) throw new Error(d.error);
    } catch (e) {
      // reverte se a chamada falhar — não deixa a tela mentir sobre o estado real
      setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, allow_system_ai: !novoValor } : x)));
      setError(e.message);
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div className="st-view">
      <div className="st-head">
        <span className="st-updated">
          {users ? `${users.length} usuário(s)` : ''}
          {users && dbInfo ? ` · Banco total ${fmtBytes(dbInfo.total)}` : ''}
        </span>
        <button className="analise-refresh" onClick={load} disabled={loading}>{loading ? '…' : 'Atualizar'}</button>
      </div>
      {error && <p className="st-msg st-err">{error}</p>}
      {loading && !users && <p className="st-msg">Carregando…</p>}

      {users && (
        <div className="st-card">
          <h3 className="st-title">👥 Usuários</h3>
          <div className="ad-table">
            {users.map((u) => (
              <div className="ad-row" key={u.id}>
                <div className="ad-row-main">
                  <span className="ad-email">{u.email}</span>
                  {u.role === 'admin' && <span className="ad-badge">admin</span>}
                  {!u.email_verified && <span className="ad-badge ad-badge-warn">não verificado</span>}
                </div>
                <div className="ad-row-sub">
                  <span>Cadastrado em {fmtDate(u.created_at)}</span>
                  <span>Custo IA: US$ {Number(u.custo_ia_usd || 0).toFixed(4)}</span>
                  <span>Banco: {fmtBytes(u.db_bytes)}</span>
                  <label className="ad-ai-toggle">
                    <input
                      type="checkbox"
                      checked={!!u.allow_system_ai}
                      disabled={savingId === u.id}
                      onChange={() => toggleAiAccess(u)}
                    />
                    IA sistema
                  </label>
                </div>
              </div>
            ))}
          </div>
          {dbInfo && (
            <p className="st-msg" style={{ marginTop: 8 }}>
              Sistema e dados sem usuário: {fmtBytes(dbInfo.outros)}. Valores estimados
              (partilha do tamanho real do arquivo pelo volume de dados de cada um).
            </p>
          )}
        </div>
      )}
      <div className="spacer"></div>
    </div>
  );
}

export default AdminTab;
